import React, { useEffect, useRef, useState } from "react";

export const Announcer = () => {
    const [message, setMessage] = useState("");
    const announcerRef = useRef<HTMLDivElement>(null);

    const onTitleChange = () => {
        setMessage(document.title);

        if (announcerRef.current) {
            announcerRef.current.focus();
        }
    };

    useEffect(() => {
        const titleElement = document.querySelector("title");
        if (!titleElement) return;

        const observer = new MutationObserver(onTitleChange);
        observer.observe(titleElement, { childList: true });

        return () => observer.disconnect();
    }, []);

    return (
        <div ref={announcerRef} aria-live="polite" className="u-sr-only" tabIndex={-1}>
            {message}
        </div>
    );
};
